// extracted by mini-css-extract-plugin
module.exports = {"items":"items_items__1sYSG","flex":"items_flex__1K4vg","text":"items_text__3ZPZ6","image":"items_image__2MkH-"};